var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / copy-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 1.96436H8.33317C7.414 1.96436 6.6665 2.71186 6.6665 3.63102V6.96436H3.33317C2.414 6.96436 1.6665 7.71186 1.6665 8.63102V16.9644C1.6665 17.8835 2.414 18.631 3.33317 18.631H11.6665C12.5857 18.631 13.3332 17.8835 13.3332 16.9644V13.631H16.6665C17.5857 13.631 18.3332 12.8835 18.3332 11.9644V3.63102C18.3332 2.71186 17.5857 1.96436 16.6665 1.96436ZM3.33317 16.9644V8.63102H11.6665L11.6682 16.9644H3.33317ZM16.6665 11.9644H13.3332V8.63102C13.3332 7.71186 12.5857 6.96436 11.6665 6.96436H8.33317V3.63102H16.6665V11.9644Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 10.2977H9.99984V11.9644H4.99984V10.2977ZM4.99984 13.631H9.99984V15.2977H4.99984V13.631Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAlt);
export default __webpack_public_path__ + "static/media/copy-alt.388f192b43203b5d22a96bc3ac9e75cd.svg";
export { ForwardRef as ReactComponent };